// docs: https://github.com/altostra/type-validations#readme
import { objectOf, arrayOf, maybe, anyOf } from "@altostra/type-validations";
import { number, string, boolean, nullValidation } from "@altostra/type-validations/lib/primitives";

const nullableString = anyOf(string, nullValidation);
const nullableNumber = anyOf(number, nullValidation);

const isAppLinkingAssignmentDetail = objectOf({
  id: string,
  hostname: string,
  hostType: string,
  hostParentId: nullableString,
  hostId: nullableString,
  configId: nullableString,
  status: string,
  iosEnabled: boolean,
  androidEnabled: boolean,
  createdAt: maybe(nullableNumber),
  activatedAt: maybe(nullableNumber),
});

export const isPutCompaniesCompanyIdCustomDomainsAppLinkingAssignmentsResult = objectOf({
  assignments: arrayOf(isAppLinkingAssignmentDetail),
});
